import React, { useState } from 'react';
import { useCurrentUser, usePhotoOptimisticEdits } from 'javascripts/hooks';
import { v1URLsFromAsset } from 'helpers/asset-utils';
import DownloadModal from 'components/photos/DownloadModal';
import SingleDownloadModal from 'components/photos/SingleDownloadModal';
import SingleVideoDownloadModal from 'components/videos/SingleVideoDownloadModal';

const NO_ACTION = null;
const NO_MODAL = () => {};
const EMPTY_RESULT = [NO_ACTION, NO_MODAL];

const databaseIdFrom = (obj) => parseInt(obj.databaseId, 10);

export default function useMenuActionDownload({ assets, assetsByType }) {
  const [modalVisible, setModalVisible] = useState(false);
  const { getOptimisticUri } = usePhotoOptimisticEdits();

  const user = useCurrentUser();

  const hasPermission = true;

  if (!hasPermission) {
    return EMPTY_RESULT;
  }

  const action = () => {
    setModalVisible(true);
  };

  const renderSingleDownloadModal = () => {
    const asset = assets[0];
    if (!asset) {
      return null;
    }

    const optimisticUri = getOptimisticUri(asset.databaseId);

    return asset.__typename === 'Video' ? (
      <SingleVideoDownloadModal
        isOpen={modalVisible}
        onRequestClose={(e) => {
          e.stopPropagation();
          setModalVisible(false);
        }}
        videoNodeId={asset.id}
      />
    ) : (
      <SingleDownloadModal
        isOpen={modalVisible}
        onRequestClose={(e) => {
          e.stopPropagation();
          setModalVisible(false);
        }}
        photo={{
          id: asset.databaseId,
          ...v1URLsFromAsset(asset, { optimisticUri }),
        }}
        companyId={user.company_id}
      />
    );
  };

  const renderMultiDownloadModal = () => (
    <DownloadModal
      isOpen={modalVisible}
      user={user}
      showVideoAlert={assetsByType.videos.length > 0}
      photos={assetsByType.photos.map(databaseIdFrom)}
      onRequestClose={() => {
        setModalVisible(false);
      }}
    />
  );

  const renderModal = () => {
    if (!modalVisible) {
      return null;
    }

    return assets.length > 1
      ? renderMultiDownloadModal()
      : renderSingleDownloadModal();
  };

  return [action, renderModal];
}
